// extracted by mini-css-extract-plugin
export default {"error_wrapper":"error-page_error_wrapper__-dhjt","error_content":"error-page_error_content__5oQIV"};